import { useSelector } from "react-redux";

import { typeInfo } from "../../../../../constants/typeInfo";
import { fillColorAtSubstance } from "../../../../../utils/textUtils";

import AntSynSymbol from "./AntSynSymbol";

const VocaCardBack = ({ currentPage }) => {
  const { mode } = useSelector((state) => state.ui);
  const isMobile = mode === "mobile";

  return (
    <div
      style={{
        transform: isMobile
          ? "scale(0.5) rotateY(180deg)"
          : "scale(1) rotateY(180deg)",
        transformOrigin: "center",
        position: "absolute",
        width: isMobile ? "200%" : "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        border: "1px solid #EBEBEB",
        borderRadius: "10px",
        boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
        backfaceVisibility: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          width: "100%",
        }}
      >
        <div
          style={{
            padding: "16px 8px",
            width: "30%",
            display: "flex",
            flexDirection: "column",
            borderRight: "1px solid #EBEBEB",
          }}
        >
          <div
            style={{
              fontSize: "32px",
              fontWeight: "bold",
              marginLeft: "24px",
              color: typeInfo["vocabulary"].color,
            }}
          >
            {currentPage.word}
          </div>
          <div
            style={{
              fontSize: "20px",
              marginLeft: "24px",
              color: "#2D2D2D",
              marginBottom: "8px",
            }}
          >
            {currentPage.pron}
          </div>
          {currentPage.syn && (
            <div
              style={{
                display: "flex",
                gap: "4px",
                color: "#2D2D2D",
                marginBottom: "4px",
              }}
            >
              <AntSynSymbol type="syn" />
              <div>
                {currentPage.syn.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                ))}
              </div>
            </div>
          )}
          {currentPage.ant && (
            <div
              style={{
                display: "flex",
                gap: "4px",
                color: "#2D2D2D",
              }}
            >
              <AntSynSymbol type="ant" />
              <div>
                {currentPage.ant.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div
          style={{
            width: "70%",
            display: "flex",
            padding: "16px 8px",
            flexDirection: "column",
            gap: "8px",
            fontSize: "18px",
            paddingLeft: "10px",
            color: "#2D2D2D",
          }}
        >
          {currentPage.kor.split("\n").map((line, index) => (
            <div key={index}>
              {fillColorAtSubstance(line, typeInfo["vocabulary"].color)}
            </div>
          ))}
          {currentPage.eng.split("\n").map((line, index) => (
            <div key={index}>
              {fillColorAtSubstance(line, typeInfo["vocabulary"].color)}
            </div>
          ))}
        </div>
      </div>
      {currentPage.example && (
        <div
          style={{
            display: "flex",
            gap: "10px",
            padding: "16px",
            paddingLeft: "32px",
            flexDirection: "column",
            alignItems: "flex-start",
            alignSelf: "stretch",
            fontSize: "18px",
            backgroundColor: "#EBEBEB",
          }}
        >
          {currentPage.example_list.map((line, index) => {
            return (
              <div
                style={{
                  lineHeight: "1.5",
                }}
              >
                <div>
                  {line
                    .split(/(\{.*?\})/g)
                    .map((part, index) =>
                      part.startsWith("{") && part.endsWith("}") ? (
                        <strong key={index}>{part.slice(1, -1)}</strong>
                      ) : (
                        part
                      )
                    )}
                </div>
                <div>{currentPage.example_translation_list[index]}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default VocaCardBack;
